module.exports = Object.freeze({
    API_URL: 'https://api-staging.staffpay.in',
    GOOGLE_MAP_ACTIVE: false,
    ENV_TYPE: 'STAGING',
    API_USER_SERVICE_PORT: 9002,
    API_AUTH_SERVICE_PORT: 9002,
    CONTROL_CENTER_API_URL: 'https://api-controlcenter-staging.loadshare.net',
    HERMES_API: 'https://api-staging.loadshare.net',
    ZAPPAY_API_URL: 'https://api-zappay-staging.staffpay.in',
    QC_LEADS_APP_URL: 'https://qc-panel-qa.vercel.app',
    MAP_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
});
